import script from "./LicensePlateView.vue?vue&type=script&lang=js"
export * from "./LicensePlateView.vue?vue&type=script&lang=js"

import "./LicensePlateView.vue?vue&type=style&index=0&id=fa31b420&lang=scss"

const __exports__ = script;

export default __exports__